import { ViewableField } from "./viewableFields";

type ElementCreatorFunc<T> = (has: (backingFieldName: string) => boolean, name: (backingFieldName: string) => string, show: boolean) => T;

/**
 * Determines whether a JSX.Element is allowed to be created. Passes the result of this determination to the creation func parameter.
 * @param getByTableType The function used to retrieve the viewable fields for a particular table type.
 * @param tableType The table type being examined.
 * @param restrictedFields The set of fields we're restricting to.
 * @param creator The function used to create the underlying JSX Element to render.
 */
function restrictByFields<T>(viewableFields: ViewableField[] = [], restrictedFields: string[], creator: ElementCreatorFunc<T>): T {
  // When restricting, we don't even consider fields that are marked as excluded.
  const excluded = viewableFields
    .filter((f) => !f.fieldExclude)
    .map<[string, ViewableField]>((f) => [f.backingFieldName, f]);

  const fields = new Map(excluded);
  const filteredFields = new Map(
    restrictedFields
      .filter((f) => fields.has(f))
      .map<[string, ViewableField]>((f) => [f, fields.get(f)]),
  );

  const has = (backingFieldName: string) => filteredFields.has(backingFieldName) && filteredFields.get(backingFieldName).visible;
  const title = (backingFieldName: string) => filteredFields.has(backingFieldName) ? filteredFields.get(backingFieldName).displayName : "";
  return creator(has, title, restrictedFields.some(has));
}

export { restrictByFields };
